module.exports = __webpack_public_path__ + "img/profits.1de95537.svg";